module.exports = __webpack_public_path__ + "static/media/nav11.c77e56d6.svg";